import {PerspectiveCamera} from 'three';

export class MapboxPerspectiveCamera extends PerspectiveCamera {}
